// extracted by mini-css-extract-plugin
module.exports = {"root":"Principles_root__ZEvtV","title":"Principles_title__Dntpj","content":"Principles_content__3rGrV","principle":"Principles_principle__9yN3N"};